import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/og.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__en-US.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

type FaqItem = { question: string; answer: string };
const faqItems = (content as unknown as { faqItems: FaqItem[] }).faqItems || [];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item: FaqItem) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    title: 'FAQ for Renters, Homeowners, Car, Pet, and Life Insurance | Lemonade',
    metaTitle: 'FAQ for Renters, Homeowners, Car, Pet, and Life Insurance | Lemonade',
    description: 'Get all your insurance questions answered in plain English - by Lemonade Insurance.',
    jsonld: [faqSchema],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
